"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveScrollbar = void 0;
var RemoveScrollbar = "\n    overflow: auto;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    ::-webkit-scrollbar{\n        display: none !important;\n        width: 0 !important;\n    }\n";
exports.RemoveScrollbar = RemoveScrollbar;